import {Pipe, PipeTransform} from '@angular/core';
import {TypeUtils} from "../utils/type-utils";
import {Utils} from "../utils/utils";

@Pipe({
  standalone: true,
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {

  transform<T>(items: T[], sortBy: any, sortDirection: 'asc'|'desc' = 'asc'): T[] {
    if (!items) {
      return items;
    }

    return Utils.sort(items, (a: any, b: any): number => {
      let aProp = a[sortBy];
      if (TypeUtils.isString(aProp)) {
        aProp = aProp.toLowerCase();
      }

      let bProp = b[sortBy];
      if (TypeUtils.isString(bProp)) {
        bProp = bProp.toLowerCase();
      }

      let returnValue = 0;
      if (aProp < bProp) {
        returnValue = -1;
      } else if (aProp > bProp) {
        returnValue = 1;
      }

      if (sortDirection === 'desc') {
        returnValue *= -1;
      }
      return returnValue;
    });
  }

}
